"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _typography = require("@vds-core/typography");

var _fonts = require("../../fonts");

var _index = require("../../index");

var Typography = function Typography(props) {
  // load fonts here if needed

  /* istanbul ignore next */
  if (_fonts.Fonts.checkFontLoaded && !_fonts.Fonts.checkFontLoaded()) {
    _fonts.Fonts.loadFonts && _fonts.Fonts.loadFonts();
    _typography.Fonts && _typography.Fonts.setFontsLoaded && _typography.Fonts.setFontsLoaded(true);
  }

  return /*#__PURE__*/_react["default"].createElement(_typography.Typography, (0, _extends2["default"])({}, props, {
    typescale: _index.TypographyConfig.getTypescale(),
    fontsconfig: _fonts.Fonts
  }));
};

var _default = Typography;
exports["default"] = _default;